import { Card, Tabs } from "antd";
import { t } from "i18next";
import { useEffect } from "react";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import AppConfig from "../../core/service/AppConfig";
import SmsLogDataGrid from "./SmsLogDataGrid";
import SmsLogFilter from "./SmsLogFilter";
import MailLogDataGrid from "./MailLogDataGrid";
import MailLogFilter from "./MailLogFilter";

export default function SmsLogApp() {
    useEffect(() => {
        document.title = `${t('Communication Logs')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('Communication Logs')}>
                <Tabs
                    defaultActiveKey="sms"
                    items={[
                        {
                            key: 'sms',
                            label: t('SMS'),
                            children: (
                                <DataGridProvider>
                                    <SmsLogFilter />
                                    <SmsLogDataGrid />
                                </DataGridProvider>
                            ),
                        },
                        {
                            key: 'mail',
                            label: t('Email'),
                            children: (
                                <DataGridProvider>
                                    <MailLogFilter />
                                    <MailLogDataGrid />
                                </DataGridProvider>
                            ),
                        },
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
